import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { onMessage } from 'firebase/messaging';
import { messaging } from './firebase';
import CommonRouts from './Routes/CommonRouts';
import { fetchLiveOrders, fetchNotificationCount, fetchUserDetails } from './redux/features/UserSlice';
import { RootState, useAppSelector, useAppDispatch } from './redux/store';
import { Notification } from './utility/Notification';
import { OrderNotificationModal } from './components/common/Model/OrderNotificationModal';
import 'sal.js/dist/sal.css'
import sal from "sal.js";

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const { isAuthenticated, user } = useAppSelector((state: RootState) => state.user);

  const [orderPayload, setOrderPayload] = useState<any>(null);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);


  const loadOrders = async () => {
    await dispatch(fetchLiveOrders());
  };

  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      dispatch(fetchNotificationCount());
      const title = payload?.notification?.title || 'New Notification';
      const body = payload?.notification?.body || '';
      console.log("payload", payload);

      const isOrder = payload?.data?.orderId;

      const isPending = payload?.data?.status === 'pending';
      if (isOrder) {
        loadOrders();
      }

      if (isOrder && isPending) {
        // Show High Priority Order Modal
        try {
          if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
          }
          audioRef.current = new Audio(`/assets/sounds/notification.mp3`);
          audioRef.current.loop = true;
          audioRef.current.play().catch(e => console.error('Audio playback failed', e));
        } catch (e) {
          console.error('Audio setup failed', e);
        }

        setOrderPayload(payload);
        setIsOrderModalOpen(true);
      } else {
        // Normal pop notification
        try {
          const audio = new Audio(`/assets/sounds/notification.mp3`);
          audio.play().catch(e => console.error('Audio playback failed', e));
        } catch (e) {
          console.error('Audio setup failed', e);
        }
        Notification(title, body);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    sal();
  }, [pathname]);

  return (
    <>
      <CommonRouts />
      <OrderNotificationModal
        open={isOrderModalOpen}
        onClose={() => {
          setIsOrderModalOpen(false);
          if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
          }
        }}
        payload={orderPayload}
      />
    </>
  );
};

export default App;
